(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrossel-clientes"] && !Shopify.designMode) return;
  try {
    

  class VAPhotoMarquee extends HTMLElement {

    connectedCallback() {

      this.viewport =
        this.querySelector(
          '.va-photo-marquee__viewport'
        );

      this.track =
        this.querySelector(
          '.va-photo-marquee__track'
        );

      this.primaryGroup =
        this.querySelector(
          '[data-va-primary]'
        );

      this.duplicateGroup =
        this.querySelector(
          '[data-va-duplicate]'
        );


      if (
        !this.viewport ||
        !this.track ||
        !this.primaryGroup ||
        !this.duplicateGroup
      ) {
        return;
      }


      this.refresh =
        this.refresh.bind(this);


      this.resizeObserver =
        new ResizeObserver(
          this.refresh
        );


      this.resizeObserver.observe(
        this.viewport
      );


      this.refresh();

    }


    disconnectedCallback() {

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

    }


    /*
      Remove cópias criadas
      anteriormente.
    */

    removeGeneratedClones(group) {

      group
        .querySelectorAll(
          '[data-va-clone]'
        )
        .forEach(
          item => item.remove()
        );

    }


    /*
      Remove atributos do
      editor Shopify das cópias.
    */

    stripShopifyAttributes(element) {

      [
        element,
        ...element.querySelectorAll('*')
      ].forEach(node => {

        Array
          .from(node.attributes || [])
          .forEach(attribute => {

            if (
              attribute.name.indexOf(
                'data-shopify'
              ) === 0
            ) {

              node.removeAttribute(
                attribute.name
              );

            }

          });

      });

    }


    /*
      Caso existam poucas fotos,
      cria cópias suficientes
      para preencher a tela.

      Isso evita espaços vazios
      no loop.
    */

    fillGroup(group, targetWidth) {

      const originalItems =
        Array.from(
          group.children
        );


      if (!originalItems.length) {
        return;
      }


      let safety = 0;


      while (
        group.scrollWidth < targetWidth &&
        safety < 20
      ) {

        originalItems.forEach(item => {

          const clone =
            item.cloneNode(true);


          clone.setAttribute(
            'data-va-clone',
            ''
          );


          clone.setAttribute(
            'aria-hidden',
            'true'
          );


          this.stripShopifyAttributes(
            clone
          );


          group.appendChild(
            clone
          );

        });


        safety += 1;

      }

    }


    /*
      Recalcula o carrossel
      para desktop/mobile
      e mudanças de largura.
    */

    refresh() {

      this.removeGeneratedClones(
        this.primaryGroup
      );

      this.removeGeneratedClones(
        this.duplicateGroup
      );


      const firstItem =
        this.primaryGroup.querySelector(
          '.va-photo-marquee__item'
        );


      const itemWidth =
        firstItem
          ? firstItem
              .getBoundingClientRect()
              .width
          : 0;


      /*
        Um pouco maior que a tela
        para garantir que nunca
        apareça espaço vazio.
      */

      const targetWidth =
        this.viewport.clientWidth +
        itemWidth;


      this.fillGroup(
        this.primaryGroup,
        targetWidth
      );


      this.fillGroup(
        this.duplicateGroup,
        targetWidth
      );


      /*
        A distância exata do
        primeiro grupo garante
        que o loop seja invisível.
      */

      const distance =
        this.primaryGroup
            .getBoundingClientRect()
            .width;


        /*
        Define a distância exata
        percorrida pelo carrossel.
        */
        this.track.style.setProperty(
        '--va-distance',
        `-${distance}px`
        );


        /*
        Mantém a mesma velocidade
        visual em qualquer tamanho
        de tela.

        Exemplo:
        50 = 50 pixels por segundo.
        */
        const styles =
        getComputedStyle(this.closest('.va-photo-marquee'));

        const pixelsPerSecond =
        parseFloat(
            styles.getPropertyValue(
            '--va-pixels-per-second'
            )
        ) || 50;


        /*
        duração = distância / velocidade
        */
        const duration =
        distance / pixelsPerSecond;


        this.track.style.setProperty(
        '--va-speed',
        `${duration}s`
        );

    }

  }


  if (
    !customElements.get(
      'va-photo-marquee'
    )
  ) {

    customElements.define(
      'va-photo-marquee',
      VAPhotoMarquee
    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
